// extracted by mini-css-extract-plugin
export default {"sendGift":"sendGift-__iMvx61","report":"report-yLwgWpxj"};